<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 特殊作业人员台账
-->
<template>
  <!-- 特种作业人员台账 -->
  <el-card class="h-full">
    <div class="h-full flex flex-col">
      <div>
        <div class="flex justify-between justify-items-center mb-10px overflow-hidden">
          <div class="flex items-center mb-5px">
            <span class="border-l-3 border-color-primary pl-10px text-18px">特种作业人员台账</span>
          </div>
          <div>
            <span class="mr-8px">选择单位:</span>
            <el-select
              :disabled="!!contractorId"
              size="small"
              v-model="formData.contractorId"
              placeholder="请选择单位"
              @change="unitChange"
              clearable
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :value="item.id"
                :label="item.orgName"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex h-415px">
          <div class="flex-1 mr-15px  border-inherit border-1 flex flex-col w-1/2">
            <h3 class="h-50px pl-10px flex text-hex-$contentTextColor items-center">
              不同工种人员分布
            </h3>
            <div class="flex-1">
              <div class="h-full pie-chart" id="ledger-pie-chart" v-if="isShowPieChart">
                <v-chart
                  v-loading="chartLoading"
                  :options="option"
                  autoresize
                  class="w-full"
                  :theme="currentTheme"
                ></v-chart>
              </div>
            </div>
          </div>
          <div class="flex-1  border-inherit border-1 px-10px w-1/2">
            <h3 class="flex justify-between h-50px text-hex-$contentTextColor items-center">
              <span>最近{{ expireDay }}天证件到期提醒</span>
              <el-button size="small" type="primary" @click="dayDialog = true">设置</el-button>
              <!-- <div class="px-10px py-6px bg-blue-500" @click="dayDialog = true">
                <i class="iconfont icon-bg-setup cursor-pointer text-white"></i>
              </div> -->
            </h3>
            <el-table
              :data="certificateTableData"
              border
              :height="tableHeight"
              stripe
              v-loading="certificateTableLoading"
            >
              <el-table-column label="序号" type="index" width="50"> </el-table-column>
              <el-table-column
                label="姓名"
                prop="personnelName"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="工种" prop="jobs" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ findWorkName(scope.row.jobs) }}
                </template>
              </el-table-column>
              <el-table-column label="提醒内容" prop="certificateName" show-overflow-tooltip>
                <!-- <template></template> -->
                <template slot-scope="scope">
                  <span
                    v-if="dayjs(scope.row.certificateDate) < dayjs(dayjs().format('YYYY-MM-DD'))"
                    >您的"{{ scope.row.certificateName }}作业证"已过期，请及时更换</span
                  >
                  <span v-else
                    >您的"{{ scope.row.certificateName }}作业证"即将过期，请及时更换</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="到期日期" prop="certificateDate">
                <template slot-scope="scope">
                  <span
                    v-if="dayjs(scope.row.certificateDate) < dayjs(dayjs().format('YYYY-MM-DD'))"
                    class="text-rose-500"
                  >
                    {{ dayjs(scope.row.certificateDate).format('YYYY-MM-DD') }}
                  </span>
                  <span v-else> {{ dayjs(scope.row.certificateDate).format('YYYY-MM-DD') }} </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="flex-1 overflow-y-auto">
        <h3 class="h-50px flex text-hex-$contentTextColor items-center pl-10px">
          不同工种人员分布详情
        </h3>
        <el-table
          :data="personTableData"
          border
          :height="tableHeight"
          stripe
          v-loading="personTableLoading"
        >
          <el-table-column label="序号" type="index" width="50"> </el-table-column>
          <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column label="工种" prop="jobs" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ wordJob(scope.row.jobs + '') }}
            </template>
          </el-table-column>
          <el-table-column
            label="持证数量"
            prop="certificateCount"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="人员状态" prop="workflowStatus" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ wordPerson(scope.row.workflowStatus + '') }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="培训课程数量"  prop="phoneNumber"></el-table-column> -->
        </el-table>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="设置证件到期提醒天数"
      :visible.sync="dayDialog"
      width="400px"
      v-dialogDrag
      @open="dialogOpened"
    >
      <div class="flex mb-10px justify-center">
        <el-input-number
          controls-position="right"
          :min="1"
          placeholder=""
          v-model="formDay"
          size="small"
          clearable
        ></el-input-number>
        <span class="ml-5px flex items-center">天</span>
      </div>
      <div class="flex justify-center">
        <el-button
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="saveForm"
          :loading="saveLoading"
          >确定</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="dayDialog = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  SpecialWorkDynamicLedgerApi,
  ContractorApi,
  ContractorAccountRelationApi,
} from '@wiz-api/contractor-management'
import { SettingApi } from '@wiz-api/setting-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

const contractorAccountRelationApi = new ContractorAccountRelationApi()
const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const dataCategoryApi = new DataCategoryApi()

const contractorApi = new ContractorApi()
const specialWorkDynamicLedgerApi = new SpecialWorkDynamicLedgerApi()
const settingApi = new SettingApi()

export default {
  name: 'special-personnel-ledger',
  computed: {
    ...mapGetters({ currentTheme: 'System/currentTheme' }),
    tableHeight() {
      return 'calc(100% - 60px)'
    },
    findWorkName() {
      return (val) => {
        return (
          this.workTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    wordJob() {
      return (value) => {
        return (
          this.workTypeList.find((item) => {
            return item.code === value
          })?.displayName || ''
        )
      }
    },

    wordPerson() {
      return (value) => {
        return (
          this.personStatusList.find((item) => {
            return item.code === value
          })?.displayName || ''
        )
      }
    },
  },
  data() {
    return {
      isShowPieChart: false,
      chartLoading: false,
      saveLoading: false,
      formDay: 1,
      expireDay: 1,
      dayDialog: false,
      contractorId: '',
      formData: {
        contractorId: '',
      },
      unitList: [],
      certificateTableData: [],
      certificateTableLoading: false,
      personTableData: [],
      personTableLoading: false,
      option: {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          bottom: '20px',
        },
        series: [
          {
            name: '工种人员分布',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      },
      workTypeList: [],
      personStatusList: [],
    }
  },
  methods: {
    async getUnit() {
      const [err, res] = await contractorApi.contractorNamesDto()
      if (!err) {
        this.unitList = res.filter((item) => {
          return item.status === 1 && item.isBlock === false
        })
      }
    },
    async saveForm() {
      const [err, res] = await settingApi.update({
        settingName: 'ContractorManagement.SystemConfigure.CertificateExpireDays',
        settingValue: this.formDay,
      })
      if (!err) {
        this.$message({
          type: 'success',
          message: '更新成功!',
        })
        this.getExpireDay()
        this.getCertificateTableData()
        this.dayDialog = false
      }
    },
    async getExpireDay() {
      const [err, res] = await settingApi.getValue(
        'ContractorManagement.SystemConfigure.CertificateExpireDays'
      )
      if (!err) {
        this.expireDay = res
      }
    },
    dialogOpened() {
      this.formDay = this.expireDay
    },
    async getEcahrtOption() {
      this.chartLoading = true
      await this.getDataCategory()
      const [err, res] = await specialWorkDynamicLedgerApi.getWorkTypeLedger({
        ...this.formData,
      })
      if (!err) {
        this.isShowPieChart = !!(res && res.length > 0)
        const data = this.workTypeList.map((item) => {
          const value =
            res.find((i) => {
              return i.name === item.code
            })?.value || 0
          return {
            name: item.displayName,
            value,
          }
        })
        this.option.series[0].data = data
      }
      this.chartLoading = false
    },
    unitChange() {
      this.getCertificateTableData()
      this.getPersonTableData()
      this.getEcahrtOption()
    },
    async getCertificateTableData() {
      const [err, res] = await specialWorkDynamicLedgerApi.getCertificateExpiredRemind({
        maxResultCount: 999,
        skipCount: 0,
        ...this.formData,
      })
      if (!err) {
        this.certificateTableData = res.items
      }
    },
    async getPersonTableData() {
      const [err, res] = await specialWorkDynamicLedgerApi.getDetail({
        maxResultCount: 999,
        skipCount: 0,
        ...this.formData,
      })
      if (!err) {
        this.personTableData = res.items
      }
    },
    async getDataCategory() {
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const codes = [
          abpConfigList.setting.values['ContractorManagement.DataCategory.Jobs'],
          abpConfigList.setting.values['ContractorManagement.DataCategory.IncomingfactoryStatus'],
        ]
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes,
          includeDetails: true,
        })
        const values = ['workTypeList', 'personStatusList']
        const codeMap = codes.reduce((pre, code, index) => {
          pre[code] = values[index]
          return pre
        }, {})
        if (!statusError) {
          const [err, res] = await dataCategoryApi.getListByIds({
            ids: statusRes.map((item) => {
              return item.id
            }),
            includeDetails: true,
          })
          if (!err) {
            res.forEach((item) => {
              this[codeMap[item.code]] = item.dataItems.map((i) => {
                return {
                  value: i.code,
                  label: i.displayName,
                  ...i,
                }
              })
            })
          }
        }
      }
    },
    async getContractorInfo() {
      // 拿承包商id和模板id
      const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
      if (!err) {
        // 检查是否是承包商
        this.formData.contractorId = res.contractorId
        this.contractorId = res.contractorId
        this.profileTemplateId = res.profileTemplateId
      }
      this.getEcahrtOption()
      this.getCertificateTableData()
      this.getPersonTableData()
    },
  },
  mounted() {
    this.getContractorInfo()
    // this.getEcahrtOption()
    // this.getCertificateTableData()
    // this.getPersonTableData()
    this.getExpireDay()
    this.getUnit()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
